"use client";
import {
  ButtonComponent,
  DividerComponent,
  ModalComponent,
} from "@/components";
import checkPopup from "@/lib/hooks/popupChecker";
import {
  useEmailDocumentMutation,
  useEmailSoareportMutation,
  useGetAvailableDocumentsQuery,
} from "@/lib/redux";
import { Email, Visibility } from "@mui/icons-material";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import DocumentEmailModals from "./email-modals";
import SoaHandler from "./soa-handler";

const tenureArray = [
  { name: "1 Month", value: 1 },
  { name: "2 Months", value: 2 },
  { name: "3 Months", value: 3 },
  { name: "6 Months", value: 6 },
];

const FileSelectModal = ({
  open,
  value,
  appId,
  direction,
  handleModal,
  radiolabel = "",
  menuItems = [],
  radioListStyle,
  ...props
}) => {
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [openConfirmEmailModal, setOpenConfirmEmailModal] = useState(false);
  const { data: documentList, isLoading: fectchingDocuments } =
    useGetAvailableDocumentsQuery({ appId }, { skip: !appId });
  const [
    emailDocument,
    {
      data: emailDocumentResponse,
      isLoading: sendingEmail,
      isError: emailError,
      isSuccess: emailSent,
    },
  ] = useEmailDocumentMutation();
  const [emailSoaReport, { data: emailSoaData }] = useEmailSoareportMutation();

  const formik = useFormik({
    initialValues: {
      emailId: "",
      documentType: "",
      appId: appId,
      period: 0,
      requestId: "",
    },
    validationSchema: Yup.object().shape({
      emailId: Yup.string()
        .email("Invalid email address")
        .required("E-mail is Required"),
      appId: Yup.string().required("Required"),
      documentType: Yup.string().required("Required"),
      period: Yup.string().when("documentType", {
        is: (val) => val === "soa",
        then: () => Yup.string().required("Tenure is Required"),
        otherwise: () => Yup.string().notRequired(),
      }),
    }),
    onSubmit: (values) => {
      if (values.documentType === "soa") {
        emailSoaReport({ ...values, email: values.emailId });
      } else {
        emailDocument(values);
      }
    },
  });

  const handleFieldChange = (e, regex) => {
    if (regex(e.target.value)) {
      formik.handleChange(e);
    }
  };

  useEffect(() => {
    if (emailSent) {
      setOpenConfirmEmailModal(true);
    }
  }, [emailSent]);
  return (
    <ModalComponent
      fullWidth
      open={open}
      maxWidth="lg"
      handleModal={handleModal}
      title={"Select Document"}
    >
      <FormControl fullWidth>
        {radiolabel && (
          <FormLabel id="demo-radio-buttons-group-label">
            {radiolabel}
          </FormLabel>
        )}
        <RadioGroup
          defaultValue=""
          name="documentType"
          value={formik?.values?.documentType}
          aria-labelledby="document Type Label"
          onChange={formik.handleChange}
          {...props}
        >
          {fectchingDocuments ? (
            <Typography>Loading....</Typography>
          ) : documentList?.data?.documents?.length > 0 ? (
            <Stack direction={direction} justifyContent="center">
              {documentList?.data?.documents?.map(
                ({ documentLabel, documentType, url }) => (
                  <Box key={documentLabel}>
                    <FormControlLabel
                      value={documentType}
                      control={<Radio />}
                      label={documentLabel}
                      sx={{ width: "100%", ...radioListStyle }}
                    />
                    <DividerComponent />
                    {documentType === formik.values.documentType &&
                      documentType !== "soa" && (
                        <Stack
                          px={3}
                          mt={1}
                          alignItems={"center"}
                          justifyContent={"space-around"}
                          direction={{ xs: "column", sm: "row" }}
                        >
                          <ButtonComponent
                            startIcon={<Visibility />}
                            onClick={() => {
                              checkPopup(url);
                            }}
                          >
                            View/Download
                          </ButtonComponent>
                          <DividerComponent
                            orientation="vertical"
                            variant="middle"
                            sx={{ height: "2em" }}
                          />
                          <ButtonComponent
                            startIcon={<Email />}
                            onClick={() => setOpenEmailModal(true)}
                          >
                            Email
                          </ButtonComponent>
                        </Stack>
                      )}
                    {documentType === formik.values.documentType &&
                      documentType === "soa" && (
                        <SoaHandler
                          appId={appId}
                          formik={formik}
                          setOpenEmailModal={setOpenEmailModal}
                          tenureArray={tenureArray}
                        />
                      )}
                  </Box>
                )
              )}
            </Stack>
          ) : (
            <Typography>No Document found</Typography>
          )}
        </RadioGroup>
      </FormControl>
      <DocumentEmailModals
        formik={formik}
        openEmailModal={openEmailModal}
        handleModal1={setOpenEmailModal}
        handleFieldChange={handleFieldChange}
        openConfirmEmailModal={openConfirmEmailModal}
        handleModal2={setOpenConfirmEmailModal}
      />
    </ModalComponent>
  );
};

export default FileSelectModal;
